import * as url from "../url_helper";

import { post } from "../api_helper";

export const addCategoryList = data => post(url.ADD_CATEGORY_LIST, data);

export const getCategoryList = (data) => post(url.GET_CATEGORY_LIST, data);

export const getOneCategory = (data) => post(url.GET_ONE_CATEGORY, data);

export const editCategory = (data) => post(url.EDIT_CATEGORY_LIST, data);

export const deleteCategory = (data) => post(url.DELETE_CATEGORY,data);
